import * as z from 'zod';
import { isoDateTimeToAppTime } from '../base-codecs';
import { LocalizedString } from '../base-schemas';
import { ReservationItemStatus } from './ReservationItemStatus';
export const BookingMatrixIntervalResource = z.object({
    start: isoDateTimeToAppTime,
    end: isoDateTimeToAppTime
});
const BookingMatrixProductResource = z.object({
    id: z.number(),
    title: LocalizedString,
    thumbnail: z.string().nullable(),
    is_individually_tracked: z.boolean(),
    stock_quantity: z.number().nullable()
});
// Per-product matrix
export const ProductMatrixReservableResource = z.object({
    id: z.number(),
    identifier: z.string(),
    is_available: z.boolean()
});
export const ProductMatrixBookingResource = z.object({
    reservation_item_id: z.number(),
    reservation_id: z.number().nullable(),
    booking_id: z.number().nullable(),
    reservable_ids: z.array(z.number()),
    customer_name: z.string().nullable(),
    interval: BookingMatrixIntervalResource,
    quantity: z.number(),
    status: ReservationItemStatus
});
export const CapacityTimelineStep = z.object({
    timestamp: isoDateTimeToAppTime,
    used_capacity: z.number(),
    reservation_item_ids: z.array(z.number())
});
const ProductMatrixBase = z.object({
    interval: BookingMatrixIntervalResource,
    product: BookingMatrixProductResource,
    bookings: z.array(ProductMatrixBookingResource)
});
const IndividuallyTrackedMatrixResource = ProductMatrixBase.extend({
    mode: z.literal('individually_tracked'),
    reservables: z.array(ProductMatrixReservableResource)
});
const PoolMatrixResource = ProductMatrixBase.extend({
    mode: z.literal('pool'),
    reservables: z.array(z.never()).default([]),
    capacity_timeline: z.array(CapacityTimelineStep)
});
export const ProductMatrixResource = z.discriminatedUnion('mode', [
    IndividuallyTrackedMatrixResource,
    PoolMatrixResource
]);
